export default __webpack_public_path__ + "img/edim-logo.56602c21.png";